import { Badge } from '@chakra-ui/react';
import { Contract } from 'shared/models/contract';
import { Product } from 'shared/models/product';
import { getBadgeVariant, getBadgeVariantByName } from './PlanBadge.types';

interface PlanBadgeProps {
  contract?: Contract;
  product?: Product;
  loading?: boolean;
}
const PlanBadge = ({ contract, product, loading }: PlanBadgeProps) => {
  const variant = contract
    ? getBadgeVariant(contract)
    : getBadgeVariantByName(product?.plan?.name ?? '');
  return (
    <Badge
      variant={loading ? 'loading' : String(variant.badgeVariant)}
      h={loading ? '32.5px' : ''}
      w={loading ? '80px' : ''}
    >
      {variant.planName}
    </Badge>
  );
};
export default PlanBadge;
